import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/CustomerStoriesPage.head';
import { CustomerStoriesPage } from '@pages/CustomerStoriesPage';

export const Route = createFileRoute('/customer-stories')({
  component: CustomerStoriesPage,
  head: () => head,
});
